import gql from 'graphql-tag';

export const mosaicSelect = gql`
  query MosaicSelect {
    mosaicSelect {
      screenViewName
      screenStyleId
      vmsId
      vmsName
    }
  }
`;

export const monitorSelect = gql`
  query monitorSelect {
    monitorSelect {
      label
      value
    }
  }
`;

export const cameraLive = gql`
  query cameraLive(
    $cameraId: String
    $startDateTime: String
    $condominiumPersonContextId: Int
  ) {
    cameraLive(
      cameraId: $cameraId
      startDateTime: $startDateTime
      condominiumPersonContextId: $condominiumPersonContextId
    ) {
      url
      porterVideo
    }
  }
`;

export const cameraStream = gql`
  query cameraStream(
    $cameraId: String
    $startDateTime: String
    $playbackInterval: Int
  ) {
    cameraStream(
      cameraId: $cameraId
      startDateTime: $startDateTime
      playbackInterval: $playbackInterval
    ) {
      porterVideo
      url
      playback
    }
  }
`;

export const cameraThumbnail = gql`
  query cameraThumbnail(
    $cameraId: String
    $dateTime: String
    $condominiumPersonContextId: Int
  ) {
    cameraPlayerThumbnail: cameraThumbnail(
      cameraId: $cameraId
      dateTime: $dateTime
      condominiumPersonContextId: $condominiumPersonContextId
    ) {
      url
    }
  }
`;

export const cameraThumbnailPlayback = gql`
  query cameraThumbnailPlayback($cameraId: ID!, $datetime: String!) {
    cameraThumbnailPlayback(cameraId: $cameraId, datetime: $datetime) {
      url
    }
  }
`;
